export const BasicType = {
  PRIVATE: 'Private',
  DOUBLE_PRIVATE: 'Dbl Private',
  MIXED_DORM: 'Mixed Dorm',
  FEMALE_DORM: 'Female Dorm',
  MALE_DORM: 'Male Dorm',
};

export const Type = {
  SINGLE: 'single',
  TWIN: 'twin',
  DOUBLE: 'double',
  TRIPLE: 'triple',
  FAMILY: 'family',
  MIXED_DORM: 'mixed_dorm',
  FEMALE_DORM: 'female_dorm',
  MALE_DORM: 'male_dorm',
};

/**
 * Returns the basicType and capacity resolved to a logical room type.
 *
 * @param {string} roomType
 * @param {number|string} roomCapacity
 * @returns {string} Logical room type key used by filters and UI.
 */
export function getType(roomType, roomCapacity) {
  switch (roomType) {
    case BasicType.MIXED_DORM:
      return Type.MIXED_DORM;
    case BasicType.FEMALE_DORM:
      return Type.FEMALE_DORM;
    case BasicType.MALE_DORM:
      return Type.MALE_DORM;
  }

  switch (Number.parseInt(roomCapacity, 10)) {
    case 1:
      return Type.SINGLE;
    case 2:
      return roomType === BasicType.DOUBLE_PRIVATE ? Type.DOUBLE : Type.TWIN;
    case 3:
      return Type.TRIPLE;
  }

  return Type.FAMILY;
}

export function isPrivate(roomType) {
  return [BasicType.PRIVATE, BasicType.DOUBLE_PRIVATE].includes(roomType);
}

export function isDorm(roomType) {
  return ![BasicType.PRIVATE, BasicType.DOUBLE_PRIVATE].includes(roomType);
}
